import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelOu.mjs'

export default function PropertiesPaneOu(props) {
    return (
        <ComponentPropertiesPane
            controllers={
                <>
                    <Text prop="ouName" />
                    <Text prop="ouUserCode" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
